import { render, staticRenderFns } from "./CrispChatButton.vue?vue&type=template&id=f3d07eba&scoped=true"
import script from "./CrispChatButton.vue?vue&type=script&lang=js"
export * from "./CrispChatButton.vue?vue&type=script&lang=js"
import style0 from "./CrispChatButton.vue?vue&type=style&index=0&id=f3d07eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d07eba",
  null
  
)

export default component.exports